<template>
  <div class="min-h-screen flex flex-col">
    <StagingBanner v-if="isNonProd" />
    <div
      :class="props.useGrayBackground === true ? 'bg-fp-gray-1' : 'bg-white'"
      class="relative grow flex"
    >
      <StaticSidebar
        v-if="!hideSidebar"
        class="hidden md:fixed md:flex md:w-64 md:flex-col"
        :class="isNonProd ? 'md:top-7 md:bottom-0' : 'md:inset-y-0'"
      >
        <slot name="sidebar" />
      </StaticSidebar>

      <div
        class="flex flex-1 overflow-x-hidden overflow-y-auto focus:outline-none"
        :class="hideSidebar ? '' : 'md:pl-64'"
      >
        <main class="relative z-0 min-w-0 flex-1 max-w-full">
          <slot />
        </main>
      </div>
    </div>
    <slot name="notifications" />
  </div>
</template>

<script lang="ts" setup>
import StagingBanner from '~/components/common/StagingBanner.vue'
import StaticSidebar from '../components/common/StaticSidebar.vue'

const isNonProd = useRuntimeConfig().public.environment !== 'prod'

const props = defineProps<{
  useGrayBackground?: boolean
  hideSidebar?: boolean
}>()

defineSlots<{
  default?: () => unknown
  sidebar?: () => unknown
  notifications?: () => unknown
}>()
</script>

<style>
html {
  scrollbar-gutter: stable;
}
</style>
